interface RidgeTextureProps {
  opacity?: string;
  className?: string;
}

export function RidgeTexture({ opacity = 'opacity-[0.045]', className = '' }: RidgeTextureProps) {
  return (
    <div className={`absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden ${className}`}>
      <svg
        viewBox="0 0 800 800"
        className={`w-[900px] h-[900px] ${opacity}`}
        fill="none"
        preserveAspectRatio="xMidYMid slice"
      >
        <path
          d="M400 180 A220 220 0 0 1 620 400"
          stroke="#6C5CE7"
          strokeWidth="1.2"
          strokeDasharray="12 8"
        />
        <path
          d="M400 220 A180 180 0 0 1 580 400"
          stroke="#F0A500"
          strokeWidth="0.8"
        />
        <path
          d="M400 140 A260 260 0 0 1 660 400"
          stroke="#6C5CE7"
          strokeWidth="1.2"
        />
        <path
          d="M180 400 A220 220 0 0 1 400 620"
          stroke="#6C5CE7"
          strokeWidth="0.8"
          strokeDasharray="8 12"
        />
        <path
          d="M220 400 A180 180 0 0 1 400 580"
          stroke="#F0A500"
          strokeWidth="1.2"
        />
        <path
          d="M340 400 A60 60 0 0 1 400 340"
          stroke="#6C5CE7"
          strokeWidth="1.2"
        />
        <circle cx="400" cy="400" r="4" fill="#F0A500" />
      </svg>
    </div>
  );
}
